/**
 * Used to identify the source of the record.
 */
export enum ApplicationSource {
    SmoovedApp = 'SmoovedApp',
    HouseMatchApp = 'HouseMatchApp',
    ExternalInfluencerApp = 'ExternalInfluencerApp'
}